export default __webpack_public_path__ + "static/default-2b20c05a597251da71cc86c3d58b83e6.png";